import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'atlasai/docs'

export const LIST_DOCS = createRequestTypes(prefix, 'LIST_DOCS')
export const [LIST_DOCS_REQUEST, LIST_DOCS_SUCCESS, LIST_DOCS_FAILURE] = LIST_DOCS

export const listDocs = createAction((params?: object) => ({
  type: LIST_DOCS,
  promise: (api: IApi) => api.atlasAI.listDocs(params),
  params,
}))

export const GET_DOC = createRequestTypes(prefix, 'GET_DOC')
export const [GET_DOC_REQUEST, GET_DOC_SUCCESS, GET_DOC_FAILURE] = GET_DOC

export const getDoc = createAction((id: string) => ({
  type: GET_DOC,
  promise: (api: IApi) => api.atlasAI.getDoc(id),
}))

export const ADD_DOC = createRequestTypes(prefix, 'ADD_DOC')
export const [ADD_DOC_REQUEST, ADD_DOC_SUCCESS, ADD_DOC_FAILURE] = ADD_DOC

export const addDoc = createAction((data: object) => ({
  type: ADD_DOC,
  promise: (api: IApi) => api.atlasAI.addDoc(data),
}))

export const UPDATE_DOC = createRequestTypes(prefix, 'UPDATE_DOC')
export const [UPDATE_DOC_REQUEST, UPDATE_DOC_SUCCESS, UPDATE_DOC_FAILURE] = UPDATE_DOC

export const updateDoc = createAction((id: string, data: object) => ({
  type: UPDATE_DOC,
  promise: (api: IApi) => api.atlasAI.updateDoc(id, data),
}))

export const DELETE_DOC = createRequestTypes(prefix, 'DELETE_DOC')
export const [DELETE_DOC_REQUEST, DELETE_DOC_SUCCESS, DELETE_DOC_FAILURE] = DELETE_DOC

export const deleteDoc = createAction((id: string) => ({
  type: DELETE_DOC,
  promise: (api: IApi) => api.atlasAI.deleteDoc(id),
}))

export const REINGEST_DOC = createRequestTypes(prefix, 'REINGEST_DOC')
export const [REINGEST_DOC_REQUEST, REINGEST_DOC_SUCCESS, REINGEST_DOC_FAILURE] = REINGEST_DOC

export const reingestDoc = createAction((id: string) => ({
  type: REINGEST_DOC,
  promise: (api: IApi) => api.atlasAI.reingestDoc(id),
}))

export const CLEAR_SELECTED_DOC = `${prefix}/CLEAR_SELECTED_DOC`

export const clearSelectedDoc = () => ({ type: CLEAR_SELECTED_DOC })
